/**
 * MemberExclusives.js
 *
 * This file contains all the route under member exclusives
 */

import View from '@/components/componentView.vue';

import { HOME } from './routeNames';

export default [
  {
    path: 'member-exclusives',
    component: View,
    children: [
      {
        isCategory: true,
        path: '',
        redirect: {
          name: HOME,
        },
      },
    ],
  },
];
